function createVersionedValueMap(versions) {
  Object.freeze(versions);
  const versionedValue = {
    atVersion(version) {
      return versions[version];
    }
  };
  Object.defineProperty(versionedValue, "$map", {
    configurable: true,
    enumerable: true,
    get() {
      return versions;
    }
  });
  return versionedValue;
}

export { createVersionedValueMap };
//# sourceMappingURL=VersionedValue.esm.js.map
